export default __webpack_public_path__ + "static/CelAnimation-Boy-1823de24626833ef31dbd03779c5e031.png";